(function () {
  var flow = window.Nineteen25Flow;
  var gate = document.querySelector('[data-age-gate]');
  if (!gate || !flow) return;

  var cookieDays = parseInt(gate.getAttribute('data-cookie-days'), 10) || 30;
  var introUrl = gate.getAttribute('data-intro-url') || '';
  var prompt = gate.querySelector('[data-age-gate-prompt]');
  var denied = gate.querySelector('[data-age-gate-denied]');
  var btnOver = gate.querySelector('[data-age-gate-over]');
  var btnUnder = gate.querySelector('[data-age-gate-under]');
  var root = document.documentElement;
  var body = document.body;
  var isDesignMode = root.classList.contains('shopify-design-mode');
  var isIntroPage = body && body.classList.contains('template-page-intro');

  function setOpen(open) {
    root.classList.toggle('age-gate-1925--open', open);
    if (!open) {
      root.classList.add('age-gate-1925--passed');
    }
  }

  function showGate() {
    gate.setAttribute('aria-hidden', 'false');
    setOpen(true);
  }

  function hideGate() {
    if (!gate) return;
    gate.setAttribute('aria-hidden', 'true');
    setOpen(false);
  }

  function redirectToIntro() {
    return false;
  }



  var promptActions = gate.querySelector('[data-age-gate-prompt-actions]');

  function showDenied() {
    if (prompt) prompt.hidden = true;
    if (promptActions) promptActions.hidden = true;
    if (denied) denied.hidden = false;
  }

  if (isDesignMode) {
    hideGate();
    return;
  }

  if (!isDesignMode && flow.hasAgeVerified()) {
    if (!flow.hasIntroSeen() && redirectToIntro()) {
      return;
    }
    hideGate();
    return;
  }

  if (!isDesignMode && root.classList.contains('age-gate-1925--passed')) {
    hideGate();
    return;
  }

  showGate();

  if (btnOver) {
    btnOver.addEventListener('click', function () {
      if (!isDesignMode) {
        flow.setAgeVerified(cookieDays);
        hideGate();
        if (window.location.pathname.indexOf('/pages/intro') !== -1) {
          window.location.replace('/');
        }
      } else {
        hideGate();
      }
    });


  }

  if (btnUnder) {
    btnUnder.addEventListener('click', function () {
      showDenied();
    });
  }
})();
